const baseStyle = {
  bg: 'white',
  borderRadius: 0,
  ring: 1,
  ringColor: 'transparent',
  boxShadow: 'sm',
}

const defaultProps = {}

const sizes = {}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
